export default __webpack_public_path__ + "static/media/logoSpinner2__backoffice.117333ea.png";